export default __webpack_public_path__ + "static/media/logo.ffa2baa6.png";